import { useSyncExternalStore } from 'react'
import { useAuthStatus } from '@renderer/hooks/use-auth-status'
import { useIsMiniNotched } from '@renderer/overlay/Mini/atoms'
import { hasNotchContent, toastManager, type ToastItem } from './toast-store'

/** `allToNotch` takes toasts with no notch content too; the notch falls back to their corner body. */
export function selectActiveNotchToast(toasts: Array<ToastItem>, allToNotch = false): ToastItem | null {
  let active: ToastItem | null = null

  for (const toast of toasts) {
    if (toast.exiting || (!allToNotch && !hasNotchContent(toast))) {
      continue
    }

    if (!active || (toast.priority ?? 0) >= (active.priority ?? 0)) {
      active = toast
    }
  }

  return active
}

/** A docked Mini hides its notch while signed out. */
export function useIsNotchShown(): boolean {
  const isNotched = useIsMiniNotched()
  const isSignedOut = useAuthStatus() === 'signedOut'
  return isNotched && !isSignedOut
}

export function useActiveNotchToast(): ToastItem | null {
  const toasts = useSyncExternalStore(toastManager.subscribe, toastManager.getToasts, toastManager.getToasts)
  return selectActiveNotchToast(toasts, useIsNotchShown())
}
